import React from "react";
import { PROMOCODE_LIMIT } from "../../../../../constants/picker-entries-constants";
import i18n from "../../../../../constants/i18n";
import getPromoCodeStore from "../../../../../stores/auditor-store/promocode-store";
import Et3Button from "../../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import ET3Div from "../../../../../core/et3-div";
import Et3Picker from "../../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../../TypesNEW";

const AllPromoCodesForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("LIMIT")}
          style={{}}
          options={PROMOCODE_LIMIT}
          value={getPromoCodeStore().allPromocodesLimit.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getPromoCodeStore().setAllPromocodesLimit(value);
          }}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={true}
        onClick={async () => {
          getPromoCodeStore().getAllPromocodes();
        }}
        type="GET"
        size="LARGE"
        text="GET"
      />
    </React.Fragment>
  );
});
export default AllPromoCodesForm;
